import { render } from "./MarkExpenseAsFullyPaid.vue?vue&type=template&id=6a1e23ee"
import script from "./MarkExpenseAsFullyPaid.vue?vue&type=script&lang=js"
export * from "./MarkExpenseAsFullyPaid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__